import { ACTIONS_ETRACK_QUOTE_APPROVAL } from '../../../constants/actionCreator';

export const initialState = {
  searchResult: null,
  searchParams: {
    quoteStatusId: ACTIONS_ETRACK_QUOTE_APPROVAL.hardwareEntitlementsId,
    customerId: 0,
    accountingGroupCode: '',
    psCustomercode: '',
  },
  quoteDetail: null,
  eTrackEntitlementSelectedData: [],
  totalQuotesRecords: 0,
};
